<script lang="ts">
    export let modalId: number
    export let id: number

    function modalOpen() {
        if (modalId !== id)
            modalId = id
        let modal = document.getElementById("modal-bg");
        modal.style.display = "block";
    }
</script>
<div on:click={() => modalOpen()}>
    <svg class="w-6 h-6 fill-current hover:text-yellow-400 transition cursor-pointer text-white" width="512" height="512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 512L416 512C427.046 512 436 503.046 436 492L436 96C436 84.954 427.046 76 416 76L302.284 76L232.142 5.85798C224.332 -1.95202 211.669 -1.95302 203.858 5.85798L133.716 76L20 76C8.95404 76 3.73335e-05 84.954 3.63679e-05 96L1.74846e-06 492C7.82784e-07 503.046 8.954 512 20 512ZM40 116L142 116C147.304 116 152.392 113.893 156.142 110.142L218 48.284L279.858 110.142C283.608 113.893 288.696 116 294 116L396 116L396 472L40 472L40 116Z"/>
        <path d="M218 245C206.402 245 197 254.404 197 266.003V405.997C197 417.596 206.402 427 218 427C229.598 427 239 417.596 239 405.997V266.003C239 254.405 229.598 245 218 245Z"/>
        <path d="M220 152C214.47 152 209.065 154.24 205.146 158.146C201.24 162.052 199 167.47 199 173C199 178.53 201.24 183.934 205.146 187.854C209.052 191.76 214.47 194 220 194C225.53 194 230.934 191.76 234.853 187.854C238.759 183.934 241 178.53 241 173C241 167.47 238.759 162.052 234.853 158.146C230.934 154.239 225.53 152 220 152Z"/>
    </svg>

</div>
